import type { MouseEvent, KeyboardEvent } from 'react';

/**
 * Stop row-level click / selection when interacting with links, buttons,
 * inputs, or other controls inside a cell (e.g. Xero Posting actions).
 */
export function stopInteractiveCellPropagation(
  event: MouseEvent | KeyboardEvent
): void {
  event.stopPropagation();
}

/**
 * Spread on a cell control or its wrapper so its clicks never reach the row. Pass the control's
 * own click handler in (`{...interactiveCellProps(() => onEdit(row))}`); an `onClick` written
 * beside the spread replaces this one, and the click then opens the row too.
 */
export function interactiveCellProps<E extends Element = Element>(
  onClick?: (event: MouseEvent<E>) => void
): {
  'data-no-row-click': '';
  onClick: (event: MouseEvent<E>) => void;
  onKeyDown: (event: KeyboardEvent) => void;
} {
  return {
    // Literal key (NO_ROW_CLICK_ATTR): the row-click guard skips anything inside it.
    'data-no-row-click': '',
    onClick: (event) => {
      stopInteractiveCellPropagation(event);
      onClick?.(event);
    },
    onKeyDown: (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        stopInteractiveCellPropagation(event);
      }
    },
  };
}
